export default (function () {
  return {};
});